<mat-card class="mat-typography">
  <mat-card-title
    *ngIf="name"
    markdown
    [content]="name"
    [context]="context"
    [enumerator]="enumerator"
    [required]="!placeholder && block.required"
  ></mat-card-title>
  <mat-card-content *ngIf="description" markdown [content]="description" [context]="context"></mat-card-content>
  <mat-form-field class="form-field-full-width">
    <input
      #ref
      type="text"
      min="0"
      matInput
      [required]="placeholder && block.required"
      [step]="block.stepSize"
      [placeholder]="placeholder || '#'"
      [value]="block.value"
      [(ngModel)]="block.value"
      (focus)="block.onFocus(ref)"
      (blur)="block.onBlur(ref)"
      (wheel)="block.onScroll($event)"
      (scroll)="block.onScroll($event)"
      (ngModelChange)="block.onValueChanged(ref, $event)"
    />
  </mat-form-field>
  <mat-card-footer *ngIf="explanation" markdown [content]="explanation" [context]="context"></mat-card-footer>
</mat-card>
